import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { Organization } from '../types/organization.type';
import { ADMIN_ORGANIZATIONS_API_PATHS } from '../constants/organizations-paths.constants';

type UpdateOrganizationParams = {
  organizationId: string;
  organizationData: Partial<Organization>;
};

type UseUpdateOrganizationResult = {
  updateOrganization: (params: UpdateOrganizationParams) => Promise<Organization | null>;
  isUpdating: boolean;
};

export function useUpdateOrganization(): UseUpdateOrganizationResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isUpdating, setIsUpdating] = useState(false);

  const updateOrganization = async ({
    organizationId,
    organizationData,
  }: UpdateOrganizationParams): Promise<Organization | null> => {
    setIsUpdating(true);

    try {
      const updatedOrganization = await HttpClient.patch<Organization>(
        ADMIN_ORGANIZATIONS_API_PATHS.UPDATE_ORGANIZATION(organizationId),
        organizationData
      );

      enqueueSnackbar("L'organisation a été mise à jour avec succès", { variant: 'success' });
      return updatedOrganization;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, "Une erreur est survenue lors de la mise à jour de l'organisation"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsUpdating(false);
    }
  };

  return { updateOrganization, isUpdating };
}
